/** One place for env — keeps import.meta.env from being scattered across components. */
export const env = {
  apiBaseUrl: (import.meta.env.VITE_API_BASE_URL as string) ?? 'http://localhost:3000/api/v1',
} as const;
